import {AbstractEvent} from "@/modules/base/events";

export default class BeforeGameLoadedEvent extends AbstractEvent {
}